import { Stack, Typography } from "@mui/material";
import { paths } from "@rms-types/constants/paths";
import { ApplicationSidebarItem } from "@rms-types/modules/application/types";

import { ApplicationStats } from "../components/application-stats";

import { SidebarItem } from "@/layouts/types";

export function generateApplicationSidebar(data: ApplicationSidebarItem[]): SidebarItem[] {
  return data.map(
    ({ organization_id, organization_name, actionable_disclosures_count, unassigned_disclosures_count }) => ({
      identifier: organization_name,
      link: paths.app.queue.details.getLink(organization_id),
      permissions: paths.app.queue.details.permissions,
      label: (
        <Stack spacing={0.5} direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontWeight={700}>{organization_name}</Typography>
          <ApplicationStats
            variant="badge"
            actionableDisclosuresCount={actionable_disclosures_count}
            unassignedDisclosuresCount={unassigned_disclosures_count}
          />
        </Stack>
      ),
    })
  );
}
